import http from '@/services/http';

/**
 * Punto de venta ARCA asignado a ESTE tenant (sucursal).
 *
 * El backend expone el campo en `GET arca/transacciones/emisor` (data.data). El nombre exacto
 * del campo puede cambiar mientras el módulo de backend termina de implementarse — se lee en
 * este único lugar (CAMPO_MI_PUNTO_VENTA) para que ajustarlo no implique tocar el resto del
 * módulo.
 */
const CAMPO_MI_PUNTO_VENTA = 'miPuntoVenta';

const state = () => ({
  miPuntoVenta: null,
  miPuntoVentaCargado: false,
  loading: false,
  error: null,
});

const getters = {
  miPuntoVenta: (state) => state.miPuntoVenta,
  miPuntoVentaCargado: (state) => state.miPuntoVentaCargado,
};

const actions = {
  /**
   * No repite el fetch si ya se cargó una vez en esta sesión (miPuntoVentaCargado) — el punto
   * de venta asignado no cambia salvo que un admin lo actualice desde Configuración ARCA.
   */
  async fetchMiPuntoVenta({ commit, state }) {
    if (state.miPuntoVentaCargado) {
      return state.miPuntoVenta;
    }

    try {
      commit('SET_LOADING', true);
      const { data } = await http.get('arca/transacciones/emisor');
      const emisor = data?.data || {};
      commit('SET_MI_PUNTO_VENTA', emisor[CAMPO_MI_PUNTO_VENTA] ?? null);
      commit('SET_ERROR', null);
      return emisor[CAMPO_MI_PUNTO_VENTA] ?? null;
    } catch (error) {
      commit('SET_ERROR', error.message || 'Error al cargar el punto de venta asignado');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

const mutations = {
  SET_MI_PUNTO_VENTA(state, valor) {
    state.miPuntoVenta = valor;
    state.miPuntoVentaCargado = true;
  },
  SET_LOADING(state, valor) {
    state.loading = valor;
  },
  SET_ERROR(state, valor) {
    state.error = valor;
  },
};

export default { namespaced: true, state, getters, actions, mutations };
